let svgSprite;
let svgSpriteElement;

function fixOldSpriteUse() {
  try {
    const allSvg = document.querySelectorAll("svg");
    allSvg.forEach(svg => {
      const use = svg.querySelector("use");
      if (use) {
        const oldXlink = use.getAttribute("xlink:href");
        const xlinkArray = oldXlink.split("#").filter(el => el.length > 0);
        if (xlinkArray.length > 1) {
          const newXlink = `#${xlinkArray[xlinkArray.length - 1]}`;
          use.setAttribute("xlink:href", newXlink);
        }
      }
    });
  } catch (e) {
    console.error(e);
  }
}

function getSvgSprite() {
  return new Promise((resolve, reject) => {
    if (!svgSprite) {
      fetch(
        `${document.documentElement.dataset.publicpath}/images/sprite.svg`,
        {
          mode: "no-cors",
          headers: {
            "Access-Control-Allow-Origin": "*"
          }
        }
      )
        .then(response => response.text())
        .then(data => {
          svgSprite = data;
          if (!svgSpriteElement) {
            svgSpriteElement = document.createElement("div");
            svgSpriteElement.setAttribute("id", "svg-icons");
            svgSpriteElement.style.display = "none";
          }
          svgSpriteElement.innerHTML = svgSprite;
          if (document.body) {
            document.body.prepend(svgSpriteElement);
            resolve();
          } else {
            getSvgSprite();
            reject();
          }
        });
    }
  });
}

getSvgSprite().then(res => {
  fixOldSpriteUse();
});



// WEBPACK FOOTER //
// ./assets/scripts/util/svgSpriteUtil.js